// Per-page SEO content. Single source of truth for titles & descriptions.
// Korean descriptions help Naver/Yeti index the site for Korean queries.

export const SEO_CONTENT = {
  home: {
    title: 'High-Performance Materials for Semiconductor, Display & Specialty Chemicals',
    description: 'LAMKO Co., Ltd. is a Korea-based technology partner for the semiconductor, OLED display, and specialty chemical industries - delivering custom synthesis, sublimation purification, and contract manufacturing at electronic grade and ultra-high purity.',
    descriptionKo: '람코(LAMKO)는 반도체, OLED 디스플레이, 정밀화학 산업을 위한 한국 기반 기술 파트너입니다. 맞춤형 합성, 승화 정제, 전자급 및 초고순도 위탁 생산 서비스를 제공합니다.',
    path: '/',
  },
  about: {
    title: 'About LAMKO',
    description: 'Founded in Korea, LAMKO Co., Ltd. brings together decades of experience in fine chemicals, OLED materials, and high-purity processing. Learn about our mission, leadership, and global manufacturing footprint.',
    descriptionKo: '람코(LAMKO)는 한국에 기반을 두고 정밀화학, OLED 소재, 고순도 가공 분야에서 수십 년의 경험을 보유한 기업입니다. 우리의 사명, 리더십, 글로벌 생산 거점을 소개합니다.',
    path: '/about',
  },
  services: {
    title: 'Services - CRDMO, CDMO, CMO',
    description: 'LAMKO offers integrated chemistry services: Contract Research (CRDMO), Contract Development & Manufacturing (CDMO), and Commercial Manufacturing (CMO) for OLED, semiconductor, and specialty chemical materials from lab scale to multi-ton production.',
    descriptionKo: '람코는 CRDMO 위탁연구, CDMO 위탁개발생산, CMO 위탁제조 등 통합 화학 서비스를 제공합니다. OLED·반도체·정밀화학 소재를 실험실 규모에서 다톤 단위까지 생산합니다.',
    path: '/services',
  },
  capabilities: {
    title: 'Capabilities - R&D, Purification & Manufacturing',
    description: 'Discover LAMKO\'s technical capabilities - R&D laboratories, multi-pass sublimation purification, ICP-MS verified analytical testing, and pilot-to-commercial production plants for high-purity materials.',
    descriptionKo: '람코의 기술 역량 - 연구개발, 다중 승화 정제, ICP-MS 분석 시험, 파일럿부터 상업 생산까지의 고순도 소재 생산 설비를 소개합니다.',
    path: '/capabilities',
  },
  industries: {
    title: 'Industries We Serve',
    description: 'LAMKO supplies advanced materials to semiconductor manufacturers, OLED display producers, battery and energy companies, and specialty chemical industries across Korea, Asia, North America, and Europe.',
    descriptionKo: '람코는 한국, 아시아, 북미, 유럽의 반도체 제조사, OLED 디스플레이 생산사, 배터리·에너지 기업, 정밀화학 산업에 첨단 소재를 공급합니다.',
    path: '/industries',
  },
  brands: {
    title: 'Platform & Brands',
    description: 'Explore LAMKO\'s portfolio of brands and platforms serving high-tech material customers worldwide, including our LUMORA chemical platform.',
    descriptionKo: '전 세계 첨단소재 고객을 위한 람코의 브랜드 및 플랫폼 포트폴리오, LUMORA 화학 플랫폼을 소개합니다.',
    path: '/brands',
  },
  partner: {
    title: 'Partner with LAMKO - Request Services',
    description: 'Submit your inquiry for CRDMO, CDMO, CMO, Purification, or Technical Consultation services. Manufacturers and suppliers can also apply to join the LAMKO partner network.',
    descriptionKo: '람코와 협력하세요. CRDMO·CDMO·CMO·정제·기술상담 문의를 제출하시거나, 제조사 및 공급사는 람코 파트너 네트워크에 지원하실 수 있습니다.',
    path: '/partner',
  },
  getInTouch: {
    title: 'Get in Touch',
    description: 'Contact LAMKO Co., Ltd. - Speak with our business development team about custom materials, OLED intermediates, purification projects, or contract manufacturing partnerships. Headquartered in Seoul, Korea.',
    descriptionKo: '람코에 문의하세요. 사업 개발팀이 맞춤형 소재, OLED 중간체, 정제 프로젝트, 위탁 제조 파트너십에 대해 안내해 드립니다. 본사: 서울, 대한민국.',
    path: '/get-in-touch',
  },
  ceoMessage: {
    title: "CEO's Message",
    description: 'A message from the leadership of LAMKO Co., Ltd. on our commitment to high-performance materials, customer partnerships, and sustainable innovation.',
    descriptionKo: '람코 리더십의 메시지 - 고성능 소재, 고객 파트너십, 지속가능한 혁신에 대한 우리의 약속.',
    path: '/ceo-message',
  },
  events: {
    title: 'Events & Exhibitions',
    description: 'Visit LAMKO at upcoming industry exhibitions including IMID, DeepTech, and other display and semiconductor events worldwide.',
    descriptionKo: 'IMID, DeepTech 등 전 세계 디스플레이·반도체 산업 전시회에서 람코를 만나보세요.',
    path: '/company/events',
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    description: "LAMKO's privacy policy - how we collect, use, and protect your personal data in compliance with Korea PIPA, EU GDPR, and other applicable regulations.",
    descriptionKo: '람코 개인정보처리방침 - 한국 개인정보보호법(PIPA), EU GDPR 등 관련 규정을 준수하여 개인정보를 수집, 이용, 보호합니다.',
    path: '/privacy-policy',
  },
  // Sub-pages
  servicesProduction: {
    title: 'Production Services (CMO)',
    description: 'LAMKO commercial-scale contract manufacturing for OLED, semiconductor, and specialty chemical products - from kilogram batches to multi-ton supply with full QA documentation.',
    descriptionKo: '람코의 상업 규모 위탁 제조(CMO) - OLED, 반도체, 정밀화학 제품을 킬로그램 단위부터 다톤 공급까지, 완전한 품질 문서와 함께 제공합니다.',
    path: '/services/production',
  },
  servicesIntegrated: {
    title: 'Integrated CRDMO Services',
    description: 'Integrated Contract Research, Development & Manufacturing (CRDMO) for materials projects - from feasibility through pilot production with a single LAMKO partner.',
    descriptionKo: '소재 프로젝트를 위한 통합 위탁연구·개발·생산(CRDMO) - 타당성 검토부터 파일럿 생산까지 단일 람코 파트너와 함께합니다.',
    path: '/services/integrated',
  },
  capabilitiesRD: {
    title: 'R&D Capabilities',
    description: "LAMKO's R&D laboratories deliver route scouting, custom synthesis, and analytical method development for next-generation OLED and semiconductor materials.",
    descriptionKo: '람코 연구개발 - 차세대 OLED 및 반도체 소재의 합성 경로 탐색, 맞춤형 합성, 분석법 개발을 수행합니다.',
    path: '/capabilities/rd',
  },
  capabilitiesPurification: {
    title: 'Purification Capabilities',
    description: 'Sublimation, recrystallization, chromatography, and zone refining - reaching ultra-high purity with ICP-MS / GD-MS verification for OLED, semiconductor, and electronic-grade materials.',
    descriptionKo: '승화, 재결정, 크로마토그래피, 존 정제 - ICP-MS/GD-MS 검증을 통해 OLED, 반도체, 전자급 소재의 초고순도를 달성합니다.',
    path: '/capabilities/purifications',
  },
  capabilitiesFacility: {
    title: 'Facility Capabilities',
    description: "LAMKO's manufacturing and laboratory facilities in Korea - equipped with electronics-grade purification, cleanroom packaging, and advanced analytical instrumentation.",
    descriptionKo: '한국 내 람코의 제조 및 연구 시설 - 다중 영역 승화, 클린룸 패키징, 첨단 분석 장비를 갖추고 있습니다.',
    path: '/capabilities/facility',
  },
  capabilitiesProductionPlants: {
    title: 'Production Plants',
    description: "LAMKO's commercial production plants - pilot to commercial-scale capacity for high-purity materials supplying global semiconductor and display customers.",
    descriptionKo: '람코의 상업 생산 공장 - 파일럿에서 상업 규모까지, 글로벌 반도체·디스플레이 고객을 위한 고순도 소재를 공급합니다.',
    path: '/capabilities/production-plants',
  },
  industriesSemiconductor: {
    title: 'Semiconductor Materials',
    description: 'LAMKO supplies high-purity precursors, organic semiconductor monomers, and electronic-grade chemicals for global semiconductor manufacturing.',
    descriptionKo: '람코는 글로벌 반도체 제조를 위한 고순도 전구체, 유기 반도체 단량체, 전자급 화학물질을 공급합니다.',
    path: '/industries/semiconductor',
  },
  industriesDisplay: {
    title: 'OLED & Display Materials',
    description: 'LAMKO is a trusted supplier of OLED emitters, host materials, and transport layer compounds - sublimed-grade purity for next-generation display panels.',
    descriptionKo: '람코는 차세대 디스플레이 패널을 위한 OLED 발광체, 호스트 소재, 수송층 화합물의 신뢰받는 공급사입니다. 승화 등급의 순도로 제공됩니다.',
    path: '/industries/display',
  },
  industriesPersonalCare: {
    title: 'Specialty Chemical Industries',
    description: 'LAMKO produces specialty chemical intermediates including flame retardants, master batches, and polymer additives for industrial applications.',
    descriptionKo: '람코는 산업용 난연제, 마스터배치, 고분자 첨가제 등 정밀화학 중간체를 생산합니다.',
    path: '/industries/personal-care',
  },
  partnerBecome: {
    title: 'Become a Partner',
    description: "Join LAMKO's partner network. CRO labs, manufacturing factories, and purification facilities - share your capabilities to qualify as a LAMKO approved partner.",
    descriptionKo: '람코 파트너 네트워크에 가입하세요. CRO 연구소, 제조 공장, 정제 시설 - 귀사의 역량을 공유하여 람코 공인 파트너로 등록하세요.',
    path: '/partner/become-partner',
  },
  quality: {
    title: 'Quality & Compliance - Electronics-Grade, Verifiable',
    description: 'Electronics-grade quality you can verify: a Certificate of Analysis on every lot, ICP-MS/OES trace-metal testing, an audited manufacturing partner network, and a documented quality system aligned to ICH Q7/Q9/Q10 and ISO 9001/14001/45001 principles.',
    descriptionKo: '검증 가능한 전자급 품질. 모든 로트의 시험성적서(CoA), ICP-MS/OES 미량 금속 분석, 감사를 거친 제조 파트너 네트워크, ICH Q7·Q9·Q10 및 ISO 9001·14001·45001 원칙에 따라 문서화된 품질 시스템.',
    path: '/quality',
  },
  products: {
    title: 'Products - OLED Emitters, Transport Materials, Organometallics',
    description: 'High-purity OLED materials and electronics-grade specialty chemicals: fluorescent, phosphorescent and TADF emitters, HTL/ETL/HIL/EIL transport and host materials, and Ir/Pt/Pd organometallics, supplied with full analytical specifications.',
    descriptionKo: '고순도 OLED 소재와 전자급 정밀화학 제품. 형광·인광·TADF 발광 재료, HTL/ETL/HIL/EIL 수송 및 호스트 소재, Ir/Pt/Pd 유기금속 화합물을 정밀 분석 사양과 함께 공급합니다.',
    path: '/products',
  },
  howWeWork: {
    title: 'How We Work - The LAMKO CRDMO Model',
    description: 'LAMKO runs a CRDMO model built for accountability: custom synthesis, electronics-grade purification and analytics in-house, with production scaled through an audited manufacturing partner network under NDA-first IP protection.',
    descriptionKo: '람코의 CRDMO 모델: 맞춤 합성, 전자급 정제, 분석은 자체 수행하고, 생산은 감사를 거친 제조 파트너 네트워크를 통해 확장합니다. NDA 우선 원칙으로 고객의 IP를 보호합니다.',
    path: '/how-we-work',
  },
  organisationChart: {
    title: 'Organisation - LAMKO Team & Structure',
    description: 'The LAMKO organisation: teams structured around R&D, quality and commercial functions for electronics-grade and specialty chemical materials.',
    descriptionKo: '람코의 조직 - 전자급 및 정밀화학 소재를 위한 연구개발, 품질, 영업 기능을 중심으로 구성된 창업자 주도의 팀입니다.',
    path: '/organisation-chart',
  },
};
